export { default } from './CarrosEletricosTipos';
